import { render } from "./artigosView.vue?vue&type=template&id=63324949"
import script from "./artigosView.vue?vue&type=script&lang=js"
export * from "./artigosView.vue?vue&type=script&lang=js"

import "./artigosView.vue?vue&type=style&index=0&id=63324949&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__